import {LitElement, html, css, svg} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement('obi-push-button-on')
export class ObiPushButtonOn extends LitElement {
  @property({type: Boolean}) useCssColor = false;

  private icon = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M19.2676 13L4.73247 13C4.38667 13.5978 3.74031 14.0001 3 14.0001C1.89543 14.0001 1 13.1046 1 12.0001C1 10.8955 1.89543 10.0001 3 10.0001C3.74026 10.0001 4.38658 10.4022 4.7324 11L19.2676 11C19.6134 10.4022 20.2597 10 21 10C22.1046 10 23 10.8954 23 12C23 13.1046 22.1046 14 21 14C20.2597 14 19.6134 13.5978 19.2676 13Z" fill="currentColor"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M3 15.0001C3.88937 15.0001 4.68751 14.6127 5.236 14L11 14V18H3C2.44772 18 2 18.4477 2 19V22H21C21.5523 22 22 21.5523 22 21V19C22 18.4477 21.5523 18 21 18H13V14L18.7641 14C19.3125 14.6127 20.1107 15 21 15C22.6569 15 24 13.6569 24 12C24 10.3431 22.6569 9 21 9C20.1107 9 19.3125 9.38731 18.7641 10H5.23589C4.68741 9.38734 3.88931 9.00006 3 9.00006C1.34315 9.00006 0 10.3432 0 12.0001C0 13.6569 1.34315 15.0001 3 15.0001ZM19.2676 13C19.6134 13.5978 20.2597 14 21 14C22.1046 14 23 13.1046 23 12C23 10.8954 22.1046 10 21 10C20.2597 10 19.6134 10.4022 19.2676 11L4.7324 11C4.38658 10.4022 3.74026 10.0001 3 10.0001C1.89543 10.0001 1 10.8955 1 12.0001C1 13.1046 1.89543 14.0001 3 14.0001C3.74031 14.0001 4.38667 13.5978 4.73247 13L19.2676 13Z" fill="currentColor"/>
</svg>
`;

  private iconCss = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M19.2676 13L4.73247 13C4.38667 13.5978 3.74031 14.0001 3 14.0001C1.89543 14.0001 1 13.1046 1 12.0001C1 10.8955 1.89543 10.0001 3 10.0001C3.74026 10.0001 4.38658 10.4022 4.7324 11L19.2676 11C19.6134 10.4022 20.2597 10 21 10C22.1046 10 23 10.8954 23 12C23 13.1046 22.1046 14 21 14C20.2597 14 19.6134 13.5978 19.2676 13Z" style="fill: var(--automation-device-primary-color)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M3 15.0001C3.88937 15.0001 4.68751 14.6127 5.236 14L11 14V18H3C2.44772 18 2 18.4477 2 19V22H21C21.5523 22 22 21.5523 22 21V19C22 18.4477 21.5523 18 21 18H13V14L18.7641 14C19.3125 14.6127 20.1107 15 21 15C22.6569 15 24 13.6569 24 12C24 10.3431 22.6569 9 21 9C20.1107 9 19.3125 9.38731 18.7641 10H5.23589C4.68741 9.38734 3.88931 9.00006 3 9.00006C1.34315 9.00006 0 10.3432 0 12.0001C0 13.6569 1.34315 15.0001 3 15.0001ZM19.2676 13C19.6134 13.5978 20.2597 14 21 14C22.1046 14 23 13.1046 23 12C23 10.8954 22.1046 10 21 10C20.2597 10 19.6134 10.4022 19.2676 11L4.7324 11C4.38658 10.4022 3.74026 10.0001 3 10.0001C1.89543 10.0001 1 10.8955 1 12.0001C1 13.1046 1.89543 14.0001 3 14.0001C3.74031 14.0001 4.38667 13.5978 4.73247 13L19.2676 13Z" style="fill: var(--automation-device-tertiary-color)"/>
</svg>
`;

  override render() {
    return html`
      <div class="wrapper">${this.useCssColor ? this.iconCss : this.icon}</div>
    `;
  }

  static override styles = css`
    .wrapper {
      height: 100%;
      width: 100%;
      line-height: 0;
    }
    .wrapper > * {
      height: 100%;
      width: 100%;
    }
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'obi-push-button-on': ObiPushButtonOn;
  }
}
